(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["happy-customers"] && !Shopify.designMode) return;
  try {
    
    const NWCustomerReviewSlider = new Swiper(".NWCustomerReviewSlider", {
        slidesPerView: 'auto',
        spaceBetween: 23,
        loop: false,
        // centeredSlides: true,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
            type: "progressbar",
        },
        breakpoints: {
          1: {
            spaceBetween: 15,
          },
          750: {
            spaceBetween: 20,
          },
          1024: {
            spaceBetween: 23,
          }
        }
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredient"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function() {
        const tabs = document.querySelectorAll('.tab-nav a');
        const tabContents = document.querySelectorAll('.tab-content');

        tabs.forEach(tab => {
            tab.addEventListener('click', function(event) {
                event.preventDefault();

                tabs.forEach(tab => tab.classList.remove('active'));
                tabContents.forEach(content => content.classList.remove('active'));
                this.classList.add('active');
                const target = document.querySelector(this.getAttribute('href'));
                target.classList.add('active');
            });
        });

        const NWIngredientsSlider = new Swiper(".NWIngredientsSlider", {
            slidesPerView: 'auto',
            spaceBetween: 23,
            loop: false,
            // centeredSlides: true,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
                type: "progressbar",
            },
            breakpoints: {
            1: {
                spaceBetween: 15,
            },
            750: {
                spaceBetween: 20,
            },
            1024: {
                spaceBetween: 23,
            }
            }
        });

    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logos-slider"] && !Shopify.designMode) return;
  try {
    
      const NWLogosSlider = new Swiper('.NWLogosSlider', {
          spaceBetween: 0,
          centeredSlides: true,
          speed: 3000,
          autoplay: {
              delay: 1,
          },
          loop: true,
          slidesPerView:'auto',
          allowTouchMove: false,
          disableOnInteraction: true
      });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["metals-health-affect"] && !Shopify.designMode) return;
  try {
    
    const NWMetalsHealthAffectSlider = new Swiper(".NWMetalsHealthAffectSlider", {
        slidesPerView: 'auto',
        spaceBetween: 23,
        loop: false,
        // centeredSlides: true,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
            type: "progressbar",
        },
        breakpoints: {
          1: {
            spaceBetween: 15,
          },
          750: {
            spaceBetween: 20,
          },
          1024: {
            spaceBetween: 23,
          }
        }
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-happy-customers"] && !Shopify.designMode) return;
  try {
    
    const NWCustomerReviewSlider = new Swiper(".NWCustomerReviewSlider", {
        slidesPerView: 'auto',
        spaceBetween: 23,
        loop: false,
        // centeredSlides: true,
        // pagination: {
        //     el: ".swiper-pagination",
        //     clickable: true,
        //     type: "progressbar",
        // },
        navigation: {
          nextEl: ".NW-happy-customer .swiper-button-next",
          prevEl: ".NW-happy-customer .swiper-button-prev",
        },
        breakpoints: {
          1: {
            spaceBetween: 15,
          },
          750: {
            spaceBetween: 20,
          },
          1024: {
            spaceBetween: 23,
          }
        }
    });

  } catch(e) { console.error(e); }
})();
})();
